import React from "react";
import { getPaymentApprovalStepperSteps } from "./utils";

import TransferTimeline from "modules/studentView/progressTimeLine";

const PaymentStatusStepper = ({ approvalJourney }) => {
  // approvalJourney is logs array
  const steps = getPaymentApprovalStepperSteps(approvalJourney || []);
  return (
    <TransferTimeline
      steps={steps}
      heading="Payment request status"
      marginLeft="0px"
      // marginBottom="0px"
    />
  );
};

export default PaymentStatusStepper;
